export const command = {
  name: 'moveCellSelectionUp',
  callback(_ref) {
    let {
      selection
    } = _ref;
    selection.markSource('keyboard');
    selection.transformStart(-1, 0);
    selection.markEndSource();
  }
};